<ca-modal-container
    modalTitle="{{ 'MODULES.INFORMATION' | translate }}"
    description=" {{ 'MODULES.PUBLISH_MODULE_DESCRIPTION' | translate }}"
    (dismiss)="dismiss('Canceled')"
>
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
        <div class="step1" *ngIf="step === 1">
            <div class="mb-3">
                <div class="d-flex flex-column-reverse">
                    <input
                        type="text"
                        class="form-control"
                        id="title"
                        placeholder="Module Title *"
                        formControlName="title"
                        [ngClass]="formGroup.get('title')?.errors && formGroup.get('title')?.touched ? 'has-error' : ''"
                    />
                    <label for="title">{{ 'GENERAL.TITLE' | translate }} <span class="red ps-1">*</span></label>
                </div>
                <small *ngIf="formGroup.get('title')?.hasError('pattern')" class="invalid-feedback">Invalid title.</small>
                <small *ngIf="formGroup.get('title')?.touched && formGroup.get('title')?.hasError('required')" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
            </div>
            <div class="mb-3">
                <div class="d-flex flex-column-reverse">
                    <textarea
                        class="form-control"
                        id="summary"
                        placeholder="{{ 'MODULES.EDITOR.SHORT_SUMMARY_PLACEHOLDER' | translate }}"
                        formControlName="summary"
                        [ngClass]="formGroup.get('summary')?.errors && formGroup.get('summary')?.touched ? 'has-error' : ''"
                    ></textarea>
                    <label for="summary">{{ 'MODULES.EDITOR.SHORT_SUMMARY_TITLE' | translate }} <span class="red ps-1">*</span></label>
                </div>
                <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('maxlength')" class="invalid-feedback">
                    {{ 'GENERAL.CANNOT_EXCEED_CHARS' | translate: { fieldName: 'Summary', limit: summaryLengthLimit } }}
                </small>
                <small *ngIf="formGroup.get('summary')?.touched && formGroup.get('summary')?.hasError('required')" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
            </div>
            <div class="description mb-3">
                <div class="d-flex flex-column-reverse form-group">
                    <ca-quill-editor-wrapper
                        formControlName="description"
                        placeholder="{{ 'MODULES.EDITOR.DESCRIPTION_PLACEHOLDER' | translate }}"
                        id="description"
                        [required]="true"
                        (touched)="onTouched()"
                        [ngClass]="description.touched && description.errors ? 'has-error' : ''"
                    ></ca-quill-editor-wrapper>
                    <label for="description">{{ 'MODULES.EDITOR.DESCRIPTION_TITLE' | translate }} <span class="red">*</span></label>
                </div>
                <small *ngIf="description.touched && description.hasError('maxlength')" class="invalid-feedback">
                    {{ 'GENERAL.CANNOT_EXCEED_CHARS' | translate: { fieldName: 'Description', limit: descriptionLengthLimit } }}
                </small>
                <small *ngIf="description.touched && description.errors?.required" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
            </div>
            <div class="file-upload-panel mb-3">
                <div class="introduction mb-4">
                    <h4 class="title">{{ 'MODULES.EDITOR.IMAGE_AND_ICON_TITLE' | translate }}</h4>
                    <span class="title-info">{{ 'MODULES.PUBLISH.PLEASE_PROVIDE_IMAGE' | translate }} <span class="red">*</span></span>
                </div>
                <div class="wrap">
                    <ca-file-upload
                        data-uit="module-publish-modal-icon-upload"
                        uploaderKey="module_publish_image_upload"
                        [allowMultipleFiles]="false"
                        [blobType]="moduleImageBlobType"
                        [maxInputSizeInBytes]="1024 * 1024"
                        [pathToAppend]="versionUnderEdit?.id"
                        [supportedFileTypes]="supportedImageTypes"
                        (invalidFiles)="updateImageUrlState($event)"
                        (onUploadCompleted)="onUploadCompleted($event)"
                    ></ca-file-upload>

                    <div class="exist-item" *ngIf="formGroup.get('imageUrl')?.value" #fileItem>
                        <span class="file-name">{{ formGroup.get('imageUrl')?.value }}</span>
                        <button type="button" class="btn ca-btn-icon ca-btn-icon-small" (click)="removeFileItem(fileItem)">
                            <ca-icon name="cross" size="s"></ca-icon>
                        </button>
                    </div>
                    <input type="text" class="form-control" formControlName="imageUrl" hidden readonly />
                </div>
                <small *ngIf="formGroup.get('imageUrl')?.hasError('required') && formGroup.get('imageUrl')?.touched" class="invalid-feedback">
                    {{ 'MODULES.EDITOR.PLEASE_PROVIDE_IMAGE' | translate }}
                </small>
                <small *ngIf="formGroup.get('imageUrl')?.hasError('maxFileSize')" class="invalid-feedback">
                    {{ (formGroup.get('imageUrl')?.errors)['maxFileSize'] }}
                </small>
                <small *ngIf="formGroup.get('imageUrl')?.hasError('invalidImageType')" class="invalid-feedback">
                    {{ (formGroup.get('imageUrl')?.errors)['invalidImageType'] }}
                </small>
            </div>
            <div>
                <div class="d-flex flex-column-reverse form-group">
                    <ng-select
                        data-uit="edit-module-category-selector"
                        formControlName="categoryId"
                        placeholder="Please select a category"
                        appendTo="body"
                        [searchable]="false"
                        [clearable]="false"
                    >
                        <ng-option *ngFor="let category of categories" [value]="category.id">
                            {{ category.name | titlecase }}
                        </ng-option>
                    </ng-select>
                    <label for="category">{{ 'GENERAL.CATEGORY' | translate }} <span class="red">*</span></label>
                </div>
                <small *ngIf="formGroup.get('categoryId')?.hasError('required') && formGroup.get('categoryId')?.touched" class="invalid-feedback">
                    {{ 'MODULES.PUBLISH.CHOOSE_CATEGORY' | translate }}
                </small>
            </div>
            <div class="mt-3">
                <span class="title-info"
                    >{{ 'MODULES.COMPLIANCE.MY_MODULE_IS_COMPLIANT' | translate }}
                    <a target="_blank" rel="noopener" href="https://docs.apeer.com/create-modules/module-guidelines"
                        >{{ 'MODULES.COMPLIANCE.MODULE_GUIDELINES' | translate }} ?</a
                    ><span class="red ps-1">*</span></span
                >
                <div caGroup class="radio-button-group" [formControlName]="'isCompliant'" data-uit="module-publish-is-compliant-radio-buttons">
                    <ca-input-radio class="check" [name]="'isCompliant'" [value]="true"> {{ 'GENERAL.YES' | translate }}</ca-input-radio>
                    <ca-input-radio class="check" [name]="'isCompliant'" [value]="false"> {{ 'GENERAL.NO' | translate }}</ca-input-radio>
                </div>
                <small *ngIf="formGroup.get('isCompliant')?.hasError('required') && formGroup.get('isCompliant')?.touched" class="invalid-feedback">
                    {{ 'MODULES.COMPLIANCE.PLEASE_CHOOSE_ONE_OPTION' | translate }}
                </small>
            </div>
            <div class="mt-3">
                <span class="title-info">{{ 'MODULES.PUBLISH.MAKE_OPEN_SOURCE_QUESTION' | translate }} <span class="red ps-1">*</span></span>
                <div caGroup class="radio-button-group" [formControlName]="'makeOpenSource'" data-uit="module-publish-make-open-source-radio-button-group">
                    <ca-input-radio class="check" [name]="'makeOpenSource'" [value]="true"
                        >{{ 'MODULES.PUBLISH.MAKE_OPEN_SOURCE_YES_ANSWER' | translate }}
                    </ca-input-radio>
                    <ca-input-radio class="check" [name]="'makeOpenSource'" [value]="false"
                        >{{ 'MODULES.PUBLISH.MAKE_OPEN_SOURCE_NO_ANSWER' | translate }}
                    </ca-input-radio>
                </div>
                <small *ngIf="formGroup.get('makeOpenSource')?.hasError('required') && formGroup.get('makeOpenSource')?.touched" class="invalid-feedback">
                    {{ 'MODULES.PUBLISH.MAKE_OPEN_SOURCE_WARNING' | translate }}
                </small>
            </div>
            <div class="w-100 d-flex justify-content-end">
                <button
                    type="button"
                    class="btn btn-primary"
                    [disabled]="!isNextButtonEnabled"
                    caAutoFocus
                    (click)="nextStep()"
                    data-uit="module-publish-next-button"
                >
                    {{ 'GENERAL.NEXT' | translate }}
                </button>
            </div>
        </div>
        <div class="step2" *ngIf="step === 2">
            <div>
                <div class="introduction">
                    <h4 class="title">Test Files</h4>
                    <span class="title-info">{{ 'MODULES.PUBLISH.PLEASE_PROVIDE_TEST_FILES' | translate }} <span class="red ps-1">*</span></span>
                    <span>{{ 'MODULES.PUBLISH.TEST_FILES_DESC' | translate }}</span>
                </div>
                <div class="file-upload-panel">
                    <ca-file-upload
                        [uploaderKey]="'module_publish_testfiles_upload_' + module.id"
                        [blobType]="testFileBlobType"
                        [pathToAppend]="versionUnderEdit?.id"
                        [allowSameFileNames]="false"
                        [errorNotificationMode]="'confirmation'"
                        [uploadValidationSelectedFiles]="testFiles"
                        (onUploadCompleted)="updateTestFileUrls($event)"
                        data-uit="module-publish-modal-file-upload"
                    ></ca-file-upload>
                    <input type="text" class="form-control" formControlName="testFileUrls" readonly hidden />
                    <div class="exist-item" *ngFor="let testFileUrl of testFileUrls">
                        <span class="file-name">{{ testFileUrl }}</span>
                        <button
                            class="btn ca-btn-icon ca-btn-icon-input"
                            type="button"
                            (click)="removeTestFileUrl(testFileUrl)"
                            data-uit="module-publish-modal-remove-test-file-button"
                        >
                            <ca-icon name="cross" size="s"></ca-icon>
                        </button>
                    </div>
                </div>
                <small *ngIf="formGroup.get('testFileUrls')?.hasError('required') && formGroup.get('testFileUrls')?.touched" class="invalid-feedback">
                    {{ 'MODULES.PUBLISH.PLEASE_PROVIDE_TEST_FILES' | translate }}
                </small>
            </div>
            <div class="statement font-s">
                <div class="agree-wrap d-flex align-items-center mb-2">
                    <ca-input-checkbox formControlName="agreeProtocol"></ca-input-checkbox>
                    I agree to the<a target="_blank" href="assets/legal/arivis_Cloud_Terms_EN.pdf">&nbsp;arivis Cloud Terms</a>.<span class="red ps-1"> *</span>
                </div>
                <small *ngIf="formGroup.get('agreeProtocol')?.touched && formGroup.get('agreeProtocol')?.hasError('required')" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
            </div>
            <div class="w-100 d-flex justify-content-end">
                <button type="button" class="btn btn-secondary me-2" (click)="goToStepOne()" data-uit="module-publish-previous-button">
                    {{ 'GENERAL.PREV' | translate }}
                </button>
                <button type="submit" [disabled]="isSubmitting || !formGroup.valid" class="btn btn-primary" caAutoFocus data-uit="module-publish-submit-button">
                    {{ 'GENERAL.SUBMIT' | translate }}
                </button>
            </div>
        </div>
    </form>
</ca-modal-container>
